"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItemLocations = getItemLocations;
function getItemLocations(itemLocations, locations) {
  var itemLocationIds = itemLocations.map(function (_ref) {
    var location = _ref.location;
    return location;
  });
  return locations.filter(function (_ref2) {
    var _id = _ref2._id;
    return itemLocationIds.includes(_id);
  });
}